export default "__VITE_ASSET__DrtsrO9F__"